import { Component, Inject, Input } from '@angular/core';

import { BookRidePlan, BookRidePriorityType, BookRideSpecification } from '@ridango/components';
import { AppStartupService } from '@ridango/core';

@Component({
    selector: 'rwidget-booking-ticket',
    templateUrl: './booking-ticket.component.html',
    styleUrls: ['./booking-ticket.component.scss']
})
export class BookingTicketComponent {
    @Input() plan: BookRidePlan;
    @Input() specification: BookRideSpecification;
    @Input() estimatedPrice: number;
    @Input() isPending: string;
    @Input() label: string;
    @Input() passengerPermission: boolean;
    @Input() customerProfile: any;
    @Input() dateFormat: string;
    infinity: number = Infinity;

    priorityType = BookRidePriorityType;

    constructor(
        @Inject('ENV') public env: any,
        public appStartupService: AppStartupService
    ) {}
}
